export const isIdColumnName = (columnName) => {
  return columnName === 'id';
};
